import styled from "styled-components";

import "../../../GlobalStyles/Font.css";
import { CustomButton } from "../../CustomButton/Button";

export const ButtonLogOut = styled(CustomButton)`
  width: 100%;
  font-size: 16px;
  font-family: "Exo2 Medium";
  line-height: 19px;
  color: #fff;
  background: #f64747;
  border-radius: 20px;
  padding: 19px;
  margin-top: 20px;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1024px) {
    width: 309px;
    font-size: 20px;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    width: 447px;
    font-size: 32px;
    line-height: 1.18;
  }
`;
